import type { EPCR } from '@/types';
import {
  activeSets as activeSetsFromFacts,
  isSetActive as isSetActiveFromFacts,
  conditionallyRequiredElements as reqElementsFromFacts,
  conditionallyRequiredTasks as reqTasksFromFacts,
  triggeredForms as triggeredFormsFromFacts,
  type ComplianceFacts,
  type ConditionalSet,
  type ConditionalSetId,
  type TriggeredForm,
} from '@moquintrend/compliance-rules';

/**
 * Thin web-app adapter over @moquintrend/compliance-rules.
 *
 * The shared package is EPCR-shape-agnostic and operates on the
 * minimal `ComplianceFacts` projection. Web-app callers keep passing
 * `EPCR` — this file does the mapping in one place.
 */

export {
  CONDITIONAL_SETS,
  TRIGGERED_FORMS,
  type ConditionalSet,
  type ConditionalSetId,
  type TriggeredForm,
  type TriggeredFormId,
} from '@moquintrend/compliance-rules';

function toFacts(epcr: EPCR): ComplianceFacts {
  return {
    patient_dob: epcr.patient_dob,
    primary_impression: epcr.primary_impression,
    secondary_impressions: epcr.secondary_impressions,
    chief_complaint: epcr.chief_complaint,
    dispatch_reason: epcr.dispatch_reason,
    possible_injury: epcr.possible_injury ?? null,
    injury_causes: epcr.injury_causes,
    transport_decision: epcr.transport_decision ?? null,
    hospital_choice_reason: epcr.hospital_choice_reason,
    report_type: epcr.report_type ?? null,
  };
}

export function activeSets(epcr: EPCR): ConditionalSet[] {
  return activeSetsFromFacts(toFacts(epcr));
}
export function isSetActive(epcr: EPCR, id: ConditionalSetId): boolean {
  return isSetActiveFromFacts(toFacts(epcr), id);
}
export function conditionallyRequiredElements(epcr: EPCR): string[] {
  return reqElementsFromFacts(toFacts(epcr));
}
export function conditionallyRequiredTasks(epcr: EPCR): string[] {
  return reqTasksFromFacts(toFacts(epcr));
}
export function triggeredForms(epcr: EPCR): TriggeredForm[] {
  return triggeredFormsFromFacts(toFacts(epcr));
}
